export const LOCAL_STORAGE_NEW_RUBRIC_ID = "newRubricId";
